import React, {Component} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import ManageAPIKeys from './ManageAPIKeys'

class ManageAPIKeysContainer extends Component {
    render() {
        const {basePath} = this.props

        return (
            <Switch>
                <Route exact path={`${basePath}/manage-apikeys`} render={() => <ManageAPIKeys {...this.props}/>}/>
                <Route path={'*'}>
                    <Redirect to={`${basePath}/manage-apikeys`}/>
                </Route>
            </Switch>
        )
    }
}

export default ManageAPIKeysContainer
